import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=0c410d70&"
import script from "./resources.vue?vue&type=script&defer=true&lang=js&"
export * from "./resources.vue?vue&type=script&defer=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports